import { NoteDto } from './note';
import { User } from './user';

export interface AiManagerPluginParams {
  enabled: boolean;
  learnMoreUrl?: string;
  haveAnIdeaUrl?: string;
  user: User;
  note: NoteDto;
  gatewayUrl: string;
  sessionId: string;
  orgId: string;
  workspaceId: string;
  aiServiceUrl: string;
  aiAccess: boolean;
  showLimitPopup?: (params: AiUsage) => void;
}

export interface AddMessageParams {
  sessionId: string;
  markdown: string;
}

export enum GetMessageActions {
  Custom = 'custom',
  Summarize = 'summarize',
  Explain = 'explain',
  Improve = 'improve',
  Fix = 'fix',
  Tasks = 'tasks',
  Shorter = 'shorter',
  Longer = 'longer',
  Continue = 'continue',
}

export interface GetMessageParams {
  sessionId: string;
  action: GetMessageActions;
  promt: string;
  outputLength: 's' | 'm' | 'l';
  voiceTone: string;
  context: string;
  onMessage: (markdown: string) => void;
}

export interface AiUsage {
  max: number;
  current: number;
}
